module.exports = __webpack_public_path__ + "static/electriciansHeaderSocket-dcae8c6a5fb90b458559ea4c59a3f9cc.png";